import * as React from 'react'
import { connect } from 'react-redux'
import { DEFAULT_STATE } from '../../store/navigation/reducer'
import { NavigationState } from '../../store/navigation/types'
import { setNavigationState } from '../../store/navigation/actions'

interface IDispatchToProps {
  setNavigationState: typeof setNavigationState
}

type IProps = IDispatchToProps & NavigationState

const Navigation = (props: IProps) => {
  React.useEffect(() => {
    const { setNavigationState, ...navigationState } = props
    setNavigationState({ ...DEFAULT_STATE, ...navigationState })
  }, [props])

  return <></>
}

const mapDispatchToProps: IDispatchToProps = {
  setNavigationState,
}
export default connect(null, mapDispatchToProps)(Navigation)